var React = require('react');

function SectionRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 144.512V49.8489L209.218 167.275V120.008L414 1.84106V98.2912L209.218 216.459L414 335.903V430.437L209.218 310.992V358.319L1 480.728V382.801L209.218 262.024L1 144.512Z","stroke":"#FFCC00","strokeOpacity":"0.5"}));
}

SectionRight.defaultProps = {"width":"251","height":"478","viewBox":"0 0 251 478","fill":"none"};

module.exports = SectionRight;

SectionRight.default = SectionRight;
